import { KlartextEventConfig } from '@common/types/klartextEventConfig';
import { FrontendSpecificConfig } from '@configTypes/eventConfigs';
import { createContext, useContext } from 'react';

export const KlartextEventConfigContext = createContext<KlartextEventConfig<FrontendSpecificConfig> | null>(null);

export const useKlartextEventConfig = () => {
  return useContext(KlartextEventConfigContext);
};
